// components/SearchFilter.js
import React from 'react';
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Box,
  Button
} from '@mui/material';
import { textFieldStyles } from '../../Login/LoginPageStyles';

const SearchFilter = ({ search, selectedPosition, onSearchChange, onPositionChange, onAddClick, positions }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, justifyContent: 'space-between' }}>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <TextField
        label="Search"
        variant="outlined"
        value={search}
        onChange={onSearchChange}
        sx={{...textFieldStyles, marginY: 2, marginRight: 2, width: 400 }}
      />
      <FormControl sx={{...textFieldStyles, marginY: 2, marginRight: 2, width: 300 }}>
        <InputLabel></InputLabel>
        <Select
          value={selectedPosition}
          onChange={onPositionChange}
          displayEmpty
        >
          <MenuItem value=""><em>All Positions</em></MenuItem>
          {positions.map((position, index) => (
            <MenuItem key={index} value={position}>{position}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
    <Button
      variant="contained"
      sx={{ backgroundColor: '#39B54A', '&:hover': { backgroundColor: '#2c8f39' } }}
      onClick={onAddClick}
    >
      Add Employee +
    </Button>
  </Box>
);

export default SearchFilter;
